module.exports = __webpack_public_path__ + "static/media/pencil.ac10f854.svg";